/**
 * Labstep
 *
 * @module screens/Metadata/Show/Thread
 * @desc Metadata show thread
 */

import { MetadataThreadDetail } from 'labstep-web/components/Metadata/Thread/Detail';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Metadata } from 'labstep-web/models/metadata';
import type React from 'react';
import type { MetadataShowThreadProps } from './types';

export const MetadataShowThreadName: React.FC<
  MetadataShowThreadProps
> = ({ id }) => (
  <EntityReadEntityContainer entityName={Metadata.entityName} id={id}>
    {({ entity }) =>
      entity ? <span>{`Notes on ${entity.label}`}</span> : null
    }
  </EntityReadEntityContainer>
);

export const MetadataShowThread: React.FC<
  MetadataShowThreadProps
> = ({ id }) => (
  <ReadOnMountHOC
    type="entities"
    loading={{ loader: 'placeholder', cached: true }}
    entityName={Metadata.entityName}
    params={{
      get_single: 1,
      id,
    }}
    children={({ entity: metadata }) => (
      <MetadataThreadDetail metadata={metadata} />
    )}
  />
);
